import React, { useState, useEffect } from 'react';
import { ModalHeader, ModalBody, Input, FormText } from 'reactstrap';
import Rodal from '../../../../components/Rodal/Rodal';
import ButtonLoader from '../../../../components/Layout/Buttons/ButtonLoader';
import './VDRRenameFolderModal.scss';

interface VDRRenameFolderModalProps {
    isVisible: boolean;
    currentName: string;
    isProcessing: boolean;
    onClose: () => void;
    onConfirm: (newName: string) => void;
}

const VDRRenameFolderModal: React.FC<VDRRenameFolderModalProps> = ({
    isVisible,
    currentName,
    isProcessing,
    onClose,
    onConfirm,
}) => {
    const [newName, setNewName] = useState<string>(currentName);

    useEffect(() => {
        if (isVisible) {
            setNewName(currentName);
        }
    }, [isVisible, currentName]);

    const handleClose = () => {
        setNewName(currentName);
        onClose();
    };

    const trimmedName = newName.trim();
    const isEmptyName = trimmedName.length === 0;
    const containsSlash = trimmedName.includes('/');
    const errorMessage = isEmptyName
        ? 'Folder name cannot be empty'
        : containsSlash
        ? 'Folder name cannot contain "/"'
        : null;
    const isFormValid =
        !isEmptyName && !containsSlash && trimmedName !== currentName;

    return (
        <div className="vdr-rename-folder-modal-container">
            <Rodal
                visible={isVisible}
                onClose={handleClose}
                animation="slideTop"
                className="vdr-rename-folder-modal"
                showMask={true}
                width={498}
                showCloseButton={true}>
                <ModalHeader>
                    <b>Rename Folder</b>
                </ModalHeader>
                <ModalBody>
                    <div className="vdr-rename-folder-form">
                        <div className="form-group">
                            <label>Folder Name</label>
                            <Input
                                type="text"
                                value={newName}
                                onChange={(e) => setNewName(e.target.value)}
                                placeholder="Enter folder name"
                                className={
                                    errorMessage
                                        ? 'form-control is-invalid'
                                        : 'form-control'
                                }
                            />
                            {errorMessage && (
                                <FormText color="danger" className="mt-1">
                                    {errorMessage}
                                </FormText>
                            )}
                        </div>

                        <div className="buttons-container">
                            <button
                                className="btn btn-outline-secondary"
                                onClick={handleClose}>
                                Cancel
                            </button>
                            <ButtonLoader
                                buttonText="Rename"
                                loaderButtonText=""
                                isLoading={isProcessing}
                                disabled={!isFormValid || isProcessing}
                                onClick={() => onConfirm(trimmedName)}
                                className="btn btn-primary"
                            />
                        </div>
                    </div>
                </ModalBody>
            </Rodal>
        </div>
    );
};

export default VDRRenameFolderModal;
